'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AR_LOCALE = exports.AR_LOCALE = 'es_AR';
var AT_LOCALE = exports.AT_LOCALE = 'de_AT';
var AU_LOCALE = exports.AU_LOCALE = 'en_AU';
var BE_LOCALE = exports.BE_LOCALE = 'nl_BE';
var BR_LOCALE = exports.BR_LOCALE = 'pt_BR';
var CA_LOCALE = exports.CA_LOCALE = 'en_CA';
var DE_CH_LOCALE = exports.DE_CH_LOCALE = 'de_CH';
var FR_CH_LOCALE = exports.FR_CH_LOCALE = 'fr_CH';
var CL_LOCALE = exports.CL_LOCALE = 'es_CL';
var CO_LOCALE = exports.CO_LOCALE = 'es_CO';
var DE_LOCALE = exports.DE_LOCALE = 'de_DE';
var DK_LOCALE = exports.DK_LOCALE = 'en_DK';
var ES_LOCALE = exports.ES_LOCALE = 'es_ES';
var FI_LOCALE = exports.FI_LOCALE = 'en_FI';
var FR_BE_LOCALE = exports.FR_BE_LOCALE = 'fr_BE';
var FR_CA_LOCALE = exports.FR_CA_LOCALE = 'fr_CA';
var FR_LOCALE = exports.FR_LOCALE = 'fr_FR';
var GB_LOCALE = exports.GB_LOCALE = 'en_GB';
var HI_IN_LOCALE = exports.HI_IN_LOCALE = 'hi_IN';
var HK_LOCALE = exports.HK_LOCALE = 'en_HK';
var IE_LOCALE = exports.IE_LOCALE = 'en_IE';
var IN_LOCALE = exports.IN_LOCALE = 'en_IN';
var IT_LOCALE = exports.IT_LOCALE = 'it_IT';
var MY_LOCALE = exports.MY_LOCALE = 'en_MY';
var MX_LOCALE = exports.MX_LOCALE = 'es_MX';
var NO_LOCALE = exports.NO_LOCALE = 'nn_NO';
var PE_LOCALE = exports.PE_LOCALE = 'es_PE';
var NL_LOCALE = exports.NL_LOCALE = 'nl_NL';
var NZ_LOCALE = exports.NZ_LOCALE = 'en_NZ';
var PT_LOCALE = exports.PT_LOCALE = 'pt_PT';
var SE_LOCALE = exports.SE_LOCALE = 'en_SE';
var SG_LOCALE = exports.SG_LOCALE = 'en_SG';
var US_LOCALE = exports.US_LOCALE = 'en_US';